<template>
  <Header></Header>
  <SideBar></SideBar>

  <Body pageTitle="Design Idea">
    <template v-slot:body>
      <TableList :config="config()"></TableList>
    </template>
  </Body>
</template>

<script>
import Header from '@/layouts/Header.vue'
import SideBar from '@/layouts/SideBar.vue'
import Body from '@/layouts/Body.vue'
import TableList from './TableList.vue'
export default {
  components: {
    Header,
    SideBar,
    Body,
    TableList
  },
  methods: {
    config() {
      return {
        showTableFilters: true,
        preload: true,
        tableId: 'design-idea',
        indexUri: 'design-idea',
        storeId: ['main']
      }
    }
  }
}
</script>

<style lang="scss">
.widget-numbers {
  cursor: pointer;
}
</style>
